export { default as CoreModelTable } from './component';
